import React from "react"
import CustomButton, { CustomButtonProps } from "../Atoms/CustomButton"
import { useNavigate } from "react-router-dom"

interface BackButtonProps extends CustomButtonProps {
  /**
   * This component has its own interface because in the future it may need its own properties
   */
}
const BackButton = ({ ...otherProps }: BackButtonProps) => {
  const navigate = useNavigate()
  return (
    <CustomButton
      icon="arrow-left"
      minimal
      onClick={e => navigate(-1)}
      {...otherProps}
    />
  )
}

export default BackButton
